"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var track_1 = __importDefault(require("../Common/utils/track"));
// Tracks challenge triggered.
exports.trackChallengeTrigger = function (workflow) {
    return track_1["default"]("web_2fa_tracking", {
        workflow: workflow,
        type: 'load'
    });
};
// Tracks contact support attempt.
exports.trackContactSupport = function (workflow) {
    return track_1["default"]("web_2fa_tracking", {
        workflow: workflow,
        type: 'get_help'
    });
};
// Fires when user confirms through a click action.
exports.trackOnClick = function (workflow) {
    return track_1["default"]("web_2fa_tracking", {
        workflow: workflow,
        type: 'action_verify'
    });
};
// Tracks success.
exports.trackOnSuccess = function (workflow) {
    return track_1["default"]("web_2fa_tracking", {
        workflow: workflow,
        type: 'action_verify_success'
    });
};
// Tracks failure.
exports.trackOnFailure = function (workflow, error) {
    return track_1["default"]("web_2fa_tracking", {
        error: error,
        workflow: workflow,
        type: 'action_verify_failure'
    });
};
// Tracks Challenge Dismiss.
exports.trackOnClose = function (workflow) {
    return track_1["default"]("web_2fa_tracking", {
        workflow: workflow,
        type: 'action_verify_close'
    });
};
// Tracks Resend Code.
exports.trackOnResendCode = function (workflow) {
    return track_1["default"]("web_2fa_tracking", {
        workflow: workflow,
        type: 'resend_code'
    });
};
// Tracks Channel Switch.
exports.trackOnChannelSwitch = function (workflow) {
    return track_1["default"]("web_2fa_tracking", {
        workflow: workflow,
        type: 'switch_channel'
    });
};
// Tracks loading of blocked page.
exports.trackOnBlockedPageTrigger = function (workflow) {
    return track_1["default"]("web_2fa_tracking", {
        workflow: workflow,
        type: 'blocked_page_load'
    });
};
// Tracks help request from blocked page.
exports.trackOnBlockedPageHelp = function (workflow) {
    return track_1["default"]("web_2fa_tracking", {
        workflow: workflow,
        type: 'blocked_page_get_help'
    });
};
